import React from 'react';
import * as RadixTabsPrimitive from '@radix-ui/react-tabs';
import {
  GenesisCoreInspector,
  styled,
  GDSStyleObject,
  GDSCustomizableComponent,
  Tabs,
  focusOutlineInner,
} from '@leagueplatform/genesis-core';

export interface GDSSegmentProps
  extends Omit<RadixTabsPrimitive.TabsTriggerProps, 'value'>,
    GDSCustomizableComponent {
  value: string;
}

const DISPLAY_NAME = 'SegmentControlButton';

export const buttonStyles: GDSStyleObject = {
  typography: '$subtitleTwo',
  backgroundColor: '$none',
  borderWidth: '$thin',
  padding: '$half $one',
  cursor: 'pointer',
  color: '$primaryTextSubdued',
  borderColor: 'transparent',
  borderRadius: '$pill',
  margin: '$none $quarter',
  width: 'fit-content',
  '&:hover': {
    backgroundColor: '$primaryBackgroundHovered',
    color: '$onSurfaceTextReversed',
  },
  '&[class*="GDS"]:focus': {
    ...focusOutlineInner,
  },
  '&:active': {
    outline: '$transparent',
  },
  '&[aria-selected="true"], &[data-state="on"]': {
    backgroundColor: '$interactiveActionPrimary',
    color: '$onSurfaceTextReversed',
  },
};

const BaseToggle = styled(Tabs.Tab, {
  ...buttonStyles,
});

export const Button: React.FC<GDSSegmentProps> = ({
  children,
  className,
  css,
  value,
  'data-testid': testId = `GDS-${DISPLAY_NAME}`,
  ...props
}) => (
  <GenesisCoreInspector displayName={DISPLAY_NAME}>
    <BaseToggle
      className={[`GDS-segment-control-button`, className].join(' ')}
      css={{
        ...css,
      }}
      key={value}
      value={value}
      data-testid={testId}
      data-segment={value}
      {...props}
    >
      {children}
    </BaseToggle>
  </GenesisCoreInspector>
);
